export default __webpack_public_path__ + "static/media/glitch40.fe0fc9d8.png";